import { render, staticRenderFns } from "./DataAnalytic.vue?vue&type=template&id=5cacbdcc&scoped=true&"
import script from "./DataAnalytic.vue?vue&type=script&lang=js&"
export * from "./DataAnalytic.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalytic.vue?vue&type=style&index=0&id=5cacbdcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cacbdcc",
  null
  
)

export default component.exports